import { connect } from 'react-redux';

import SignUpTemplate from './SignUpTemplate';
import { selectors } from '../../../dux/user';

const mapStateToProps = (state) => ({
  primaryEmail: selectors.getIdentityState(state).email,
});

export default connect(mapStateToProps, null)(SignUpTemplate);
